import { useQuery } from "@tanstack/react-query";
import { api, throwIfError } from "../client";
import { platformWeighingKeys, wingWeighingKeys } from "../query-keys";
import type { WingConfig } from "@/types/identifiers";

export function useFleetPlatformWeighings() {
  return useQuery({
    queryKey: platformWeighingKeys.fleet(),
    queryFn: async () => {
      const result = await api.GET("/api/fleet/weighings/platforms", {});
      return throwIfError(result, "Failed to fetch fleet platform weighings");
    },
  });
}

export function useFleetWingWeighings(config: WingConfig) {
  return useQuery({
    queryKey: wingWeighingKeys.fleet(config),
    queryFn: async () => {
      const result = await api.GET("/api/fleet/weighings/wings", {
        params: { query: { config } },
      });
      return throwIfError(result, "Failed to fetch fleet wing weighings");
    },
  });
}
